export const filterOperations = ['<', '>', '<=', '>=', '=', 'startsWith', 'endsWith', 'includes'] as const;
export type FilterOperation = typeof filterOperations[number];
